export default __webpack_public_path__ + "static/media/img3.707f726a.jpg";